// let url = 'wss://talk.bangqichat.com/acc' /*线上地址*/
let url = 'ws://192.168.0.246:15114/acc' /*本地测试地址*/
let ws, tt, lockReconnect = false;//避免重复连接
let isLogin = false /*是否已登录*/
import store from "@/store";
//生成消息id
function sendId() {
    let id = currentTime() + "-" + randomNumber(100000, 999999);
    return id
}

let userInfo = JSON.parse(sessionStorage.getItem('CustomInfo'));

//获取当期时间戳
function currentTime() {
    return (new Date()).valueOf();
}

//生成随机数
function randomNumber(minNum, maxNum) {
    switch (arguments.length) {
        case 1:
            return parseInt(Math.random() * minNum + 1, 10);
            break;
        case 2:
            return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
            break;
        default:
            return 0;
            break;
    }
}

let websocket = {
    Init: function () {
        if ("WebSocket" in window) {
            ws = new WebSocket(url);
        } else {
            console.log("您的浏览器不支持 WebSocket!");
            return;
        }
        ws.onmessage = function (e) {
            heartCheck.start()
            //心跳消息不做处理
            if (JSON.parse(e.data).cmd == 'heartbeat') {
                return false;
            }else if (JSON.parse(e.data).msg == 'socket连接成功') {
                isLogin = true;
            } else {
                console.log("接收消息:", JSON.parse(e.data))
                messageHandle(e.data)
            }
        }
        ws.onclose = function () {
            console.log("连接已关闭")
            // Message({message: '连接已关闭', type: 'error'});
            reconnect();
        }
        ws.onopen = function () {
            console.log("连接成功")
            // Message({message: '连接成功', type: 'success'});
            if (!isLogin) {
                login();
            }
            heartCheck.start();
        }
        ws.onerror = function (e) {
            console.log("数据传输发生错误");
            // Message({message: '数据传输发生错误', type: 'error'});
            reconnect()
        }
    },
    Send: function (platformId, commonTuid, innerVal, commonTuname, time, commonRoomId,typeName) {
        // 消息体
        let sendMessage = {
            seq: sendId(),			    //	消息id
            cmd: "msg",					//	消息标识（login：登录 ， msg：消息 , heartbeat：心跳）
            appId: platformId, 				//	平台标识（3：客服系统，5：帮企网app）
            userId: userInfo.cid.toString(), 			//	发送者id
            target: commonTuid, 		//	接收者id（群聊时：发送多个对象时中间用英文逗号隔开，如（47,49,46））
            msgId: sendId(), 			//	消息id
            message: innerVal, 			//	消息内容
            data: {
                appId: 5, 			//	平台标识（3：客服系统，5：帮企网app）
                userId: userInfo.cid.toString(), 		//	发送者id	固定必传参数*
                userName: userInfo.userID, 	//	发送者昵称	固定必传参数*
                userAvatar: userInfo.useravatar, //	发送者头像	固定必传参数*
                msgId: sendId(), 		//	消息id
                isService: "3", 		//  表示该消息将发送到哪个平台（3：客服系统，5：帮企网app）
                type: typeName,			//	消息类型（TEXT:文字 PIC:图片 LINK:链接 MAP:地图 AUDIO:语言 VIDEO:视频 FILE:文件 CARD:名片）
                user_type: "single",	//	聊天方式（single：私聊，many：群聊）
                text: innerVal, 		//  消息内容
                source: "帮企网", 		//  来源：客服，帮企网，
                roomId: commonRoomId, 	//  房间号
                time: time, 			//  消息发送时间(13位时间戳，毫秒级)
                tuid: commonTuid,		//	接收者id
                toName: commonTuname,	//	接收者昵称
            }
        }
        let msg = JSON.stringify(sendMessage);
        store.commit('SET_ChatMessage',sendMessage.data);
        window.isMove=true;
        ws.send(msg)
    },
    getWebSocket() {
        return ws;
    },
    getStatus() {
        if (ws.readyState == 0) {
            return "未连接";
        } else if (ws.readyState == 1) {
            return "已连接";
        } else if (ws.readyState == 2) {
            return "连接正在关闭";
        } else if (ws.readyState == 3) {
            return "连接已关闭";
        }
    },
    closeWebSocket() {
        ws.close();
    },
}
export default websocket;

//根据消息标识做不同的处理
function messageHandle(message) {
    let msg = JSON.parse(message)
    store.commit('SET_ChatMessage',msg.data);
    window.isMove=true;
}

function reconnect() {
    if (lockReconnect) {
        return;
    }
    lockReconnect = true;
    //没连接上会一直重连，设置延迟避免请求过多
    tt && clearTimeout(tt);
    tt = setTimeout(function () {
        websocket.Init();
        lockReconnect = false;
    }, 4000)
}
//登录
function login() {
    let loginData = {
        seq: sendId(),					//	消息id
        cmd: "login",						//	消息标识（login：登录 ， msg：消息 , heartbeat：心跳）
        data: {
            appId: 5,					//	平台标识（3：客服系统，5：帮企网app）
            userId: userInfo.cid.toString(),	//	发送者id
            userName: userInfo.userID,			//	发送者昵称
            userAvatar: userInfo.useravatar		//	发送者头像
        }
    }
    ws.send(JSON.stringify(loginData))
}

//心跳检测
let heartCheck = {
    timeout: 1000 * 30,
    timeoutObj: null,
    serverTimeoutObj: null,
    start: function () {
        let self = this;
        this.timeoutObj && clearTimeout(this.timeoutObj);
        this.serverTimeoutObj && clearTimeout(this.serverTimeoutObj);
        this.timeoutObj = setTimeout(function () {
            //这里发送一个心跳，后端收到后，返回一个心跳消息，
            //onmessage拿到返回的心跳就说明连接正常
            console.log('心跳检测...');
            ws.send(JSON.stringify({seq: sendId(), cmd: "heartbeat", data: {}}))
            self.serverTimeoutObj = setTimeout(function () {
                if (ws.readyState != 1) {
                    ws.close();
                }
            }, self.timeout)
        }, this.timeout)
    }
}